export default __webpack_public_path__ + "static/media/path.2f6fd1bc.svg";